export const OUTLOOK_BACKFILL_BODY_MARKER =
  '[Backfilled from Outlook Sent — original body not preserved in the log.]';

/** Detect Outlook Sent-folder backfill rows (source prefix preferred, body marker fallback). */
export function isOutlookBackfilledMessage(item) {
  if (!item || typeof item !== 'object') return false;

  const source = String(item.source || '');
  if (source.startsWith('backfill_')) return true;

  const bodyCandidates = [
    item.body_html,
    item.bodyHtml,
    item.body,
    item.html,
    item.body_plain,
    item.bodyPlain,
  ];

  return bodyCandidates.some(
    (value) => value != null && String(value).includes(OUTLOOK_BACKFILL_BODY_MARKER),
  );
}
